import { createFileRoute } from "@tanstack/react-router";
import { BlogPostPage } from "@/components/site/BlogPostPage";
import { POST_BY_SLUG } from "@/lib/blog";
import { articleSchema, faqSchema, breadcrumbSchema } from "@/components/site/SchemaJsonLd";

const SLUG = "why-phoenix-hard-water-is-destroying-your-pipes-and-what-to-do-about-it";
const post = POST_BY_SLUG[SLUG];

export const Route = createFileRoute(
  "/why-phoenix-hard-water-is-destroying-your-pipes-and-what-to-do-about-it",
)({
  head: () => ({
    meta: [
      { title: "Why Phoenix Hard Water Destroys Pipes (and What to Do)" },
      { name: "description", content: post.description },
      { property: "og:title", content: post.title },
      { property: "og:description", content: post.description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: `https://www.phoenixplumbing.co/${SLUG}` },
      { name: "twitter:title", content: post.title },
      { name: "twitter:description", content: post.description },
    ],
    links: [{ rel: "canonical", href: `https://www.phoenixplumbing.co/${SLUG}` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(articleSchema({ title: post.title, description: post.description, date: post.date, slug: SLUG })) },
      ...(post.faqs ? [{ type: "application/ld+json", children: JSON.stringify(faqSchema(post.faqs)) }] : []),
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Blog", url: "/blog" }, { name: post.title, url: `/${SLUG}` }])) },
    ],
  }),
  component: () => <BlogPostPage post={post} />,
});
